import ToggleButtonGroup, {
    toggleButtonGroupClasses,
} from '@mui/material/ToggleButtonGroup';
import { Route, Routes } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { selectedToolState } from '~/state/atoms/toolsAtoms';
import BrushToolComponent from './brush-tool';
import LineDrawToolComponent from './line-tool';
import PanningTool from './panning-tool';
import WindowingTool from './windowing-tool';

const autoSegmentationWorkflowTools = [
    PanningTool,
    WindowingTool,
    BrushToolComponent,
    LineDrawToolComponent,
];

const dosePredictionWorkflowTools = [PanningTool, WindowingTool];

export default function Tooling() {
    const [tool] = useRecoilState(selectedToolState);

    return (
        <ToggleButtonGroup
            value={tool}
            exclusive
            color="primary"
            aria-label="text alignment"
            sx={(theme) => ({
                [`&.${toggleButtonGroupClasses.root}`]: {
                    columnGap: theme.spacing(1),
                    ':disabled': {
                        color: 'black',
                    },
                    [`& .${toggleButtonGroupClasses.middleButton}, & .${toggleButtonGroupClasses.lastButton}, & .${toggleButtonGroupClasses.firstButton}`]:
                        {
                            borderRadius: `${theme.shape.borderRadius}px`,
                            borderLeft: `1px solid ${theme.palette.divider}`,
                        },
                },
            })}
        >
            <Routes>
                <Route
                    path="contour/*"
                    element={autoSegmentationWorkflowTools.map(
                        (Tool, index) => (
                            <Tool key={index} />
                        )
                    )}
                />
                <Route
                    path="dose/*"
                    element={dosePredictionWorkflowTools.map((Tool, index) => (
                        <Tool key={index} />
                    ))}
                />
                <Route
                    path="*"
                    element={autoSegmentationWorkflowTools.map(
                        (Tool, index) => (
                            <Tool key={index} />
                        )
                    )}
                />
            </Routes>
        </ToggleButtonGroup>
    );
}
